<udex-filter-menu
  [filterName]="selectedOptionName"
  [filterNamePrefix]="placeholder"
  placement-type="Bottom"
  horizontal-align="Right"
  (selectionChange)="getSortCode($event)"
  data-cy="list-sorting"
>
  <ng-container *ngFor="let sort of sortOptions">
    <udex-filter-menu-item
      [label]="sort.name ? sort.name : sortLabels ? sortLabels[sort.code] : ''"
      data-cy="list-sorting-name"
      [selected]="selectedOption == sort.code"
    >
    </udex-filter-menu-item>
  </ng-container>
</udex-filter-menu>
